import React from 'react';
import { ScheduleCellProps } from './types';

const LanguageCell: React.FC<
  ScheduleCellProps & {
    languages: any[];
  }
> = ({ row, languages }) => {
  const offering = row?.original;

  const lan = languages?.find((l) => l.token === offering.instruction_language);

  return (lan && lan?.display_name) || offering.instruction_language || '';
};

export default LanguageCell;
